<template>
    <!-- 门禁设备 -->
    <div class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">设备编号</div>
                        <input type="text" class="input_box" placeholder="请输入设备编号" v-model="searchNumber" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">设备名称</div>
                        <input type="text" class="input_box" placeholder="请输入设备名称" v-model="searchName" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">设备记录类型</div>
                        <el-select size="small" v-model="searchRecordType" filterable placeholder="请选择"
                            :popper-append-to-body="false" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option label="无效" value="0">无效</el-option>
                            <el-option label="进门" value="1">进门</el-option>
                            <el-option label="出门" value="2">出门</el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">设备型号</div>
                        <el-select size="small" v-model="searchModel" filterable placeholder="请选择"
                            :popper-append-to-body="false" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option label="XT-R1" value="XT-R1">XT-R1</el-option>
                            <el-option label="XT-R2" value="XT-R2">XT-R2</el-option>
                            <el-option label="XT-R3" value="XT-R3">XT-R3</el-option>
                            <el-option label="XT-R5" value="XT-R5">XT-R5</el-option>
                            <el-option label="XT-R6" value="XT-R6">XT-R6</el-option>
                            <el-option label="XT-R7" value="XT-R7">XT-R7</el-option>
                            <el-option label="XT-R8" value="XT-R8">XT-R8</el-option>
                            <el-option label="XT-K1" value="XT-K1">XT-K1</el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">设备类型</div>
                        <el-select size="small" v-model="searchType" filterable placeholder="请选择"
                            :popper-append-to-body="false" style="border-radius: 0; vertical-align: bottom">
                            <el-option label="请选择" value></el-option>
                            <el-option label="人脸识别" value="0">人脸识别</el-option>
                            <el-option label="门禁控制卡" value="1">门禁控制卡</el-option>
                        </el-select>
                    </div>
                </div>
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">安装时间</div>
                        <el-date-picker size="small" v-model="searchSignDate" type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:392px;border-bottom-left-radius: 0;border-top-left-radius: 0;"></el-date-picker>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">设备名称</div>
                    <div class="title_item">SN</div>
                    <div class="title_item">LAN IP</div>
                    <div class="title_item">方向</div>
                    <div class="title_item">类型</div>
                    <div class="title_item">设备型号</div>
                    <div class="title_item">状态</div>
                    <div class="title_item">安装时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="cardData">
                            <div class="box_line" v-for="(item, index) in cardData" :key="index">
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item">{{ item.sn }}</div>
                                <div class="list_item">{{ item.lanIP }}</div>
                                <div class="list_item" v-if="item.type == 0">
                                    <span v-if="item.record_type == 0" style="color: #F56C6C">无效</span>
                                    <span v-else-if="item.record_type == 1">进门</span>
                                    <span v-else>出门</span>
                                </div>
                                <div class="list_item" v-else>进 | 出</div>
                                <div class="list_item" :title="fnGetType(item.type)">
                                    <span v-if="item.type == 0"><svg-icon icon-class="face-recognition"
                                            style="width: 1.8em;height: 1.8em" /></span>
                                    <span v-else><svg-icon icon-class="IC-card"
                                            style="width: 1.8em;height: 1.8em" /></span>
                                </div>
                                <div class="list_item">{{ item.model }}</div>
                                <div class="list_item" :title="fnOnlineStatusText(item.heartbeatTime).date | fnAccess">
                                    <span v-if="fnOnlineStatusText(item.heartbeatTime).status == 0"
                                        style="color: #E6A23C">{{ fnOnlineStatusText(item.heartbeatTime).text }}</span>
                                    <span v-else>{{ fnOnlineStatusText(item.heartbeatTime).text }}</span>
                                </div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div>
                                        <div class="search-btn btn_orange" @click="fnOpenDoor(item)"><span>远程开门</span>
                                        </div>
                                        <div class="search-btn" @click="fnOpenEditWin(item)"><span>编辑</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination background class="pagination" :page-sizes="pageSizes" :page-size="pageSize"
                    :current-page="currentPage" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
            <div class="dialog_editdevice animate__animated animate__fadeIn" v-if="addEqptVisible">
                <el-dialog title="编辑设备" :modal="false" :visible.sync="addEqptVisible" center style="text-align: center">
                    <div class="search_box" style="width:100%;height:150px;margin:auto;">
                        <div class="box_line">
                            <div class="line_input" style="margin:auto;">
                                <div class="input_title">SN</div>
                                <input type="text" disabled="disabled" readonly="readonly" class="input_box"
                                    placeholder="请输入设备名" v-model="form.sn" />
                            </div>
                        </div>
                        <div class="box_line">
                            <div class="line_input" style="margin:auto;">
                                <div class="input_title">记录类型</div>
                                <el-select size="small" v-model="form.record_type" filterable placeholder="请选择"
                                    :popper-append-to-body="false" style="border-radius: 0; vertical-align: bottom">
                                    <el-option label="请选择" value></el-option>
                                    <el-option label="无效" value="0">无效</el-option>
                                    <el-option label="进门" value="1">进门</el-option>
                                    <el-option label="出门" value="2">出门</el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="box_line">
                            <div class="line_input" style="margin:auto;">
                                <div class="input_title">设备名</div>
                                <input type="text" class="input_box" placeholder="请输入设备名" v-model="form.name" />
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                        <div class="btn_line">
                            <div class="search-btn red" @click="addEqptVisible = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnEditEqpt"><span>确定</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        getUserInfo
    } from '@/utils/auth';

    export default {
        data() {
            return {
                pageSize: APP.PAGE.LIMIT,
                pageSizes: APP.PAGE.SIZE_OPTION,
                currentPage: APP.PAGE.SKIP_PAGE,
                pageTotal: 0,
                addEqptVisible: false,
                searchNumber: '',
                searchName: '',
                searchRecordType: '',
                searchModel: '',
                searchType: '',
                searchStatus: '',
                searchSignDate: '',
                cardData: [],
                serchtime: '',
                form: {
                    type: '', // string 设备类型
                    sn: '', // string 设备编号 （必填）
                    name: '', // string 设备名称
                    record_type: '0' // string 记录类型
                }
            };
        },
        created() {
            this.fnGetData({
                page: this.currentPage,
                size: this.pageSize
            });
        },
        methods: {
            // 更改分页内容
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnSearch(false);
            },
            // 翻页
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnSearch(false);
            },
            //获取设备数据
            fnGetData(_obj) {
                request({
                        url: '/accessEqpt/get',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        this.cardData = res.data.query;
                        this.pageTotal = res.data.count;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 获取门禁设备类型
            fnGetType(_type) {
                return _type == 0 ? '人脸识别' : '门禁控制卡';
            },
            // 门禁设备在线状态
            fnOnlineStatusText(_heartbeatTime) {
                let _text = _heartbeatTime ? '' : '离线';
                let _status = 0;
                let _time = new Date().getTime();
                let _differentTime = 1000 * 60 * 2; // 心跳间隔时间，两分钟
                let _btime = '无';
                if (_heartbeatTime && _heartbeatTime != 0) {
                    let _different = _time - _heartbeatTime * 1000;
                    _text = _different >= _differentTime ? '离线' : '在线';
                    _status = _different >= _differentTime ? 0 : 1;
                    _btime = new Date(_heartbeatTime * 1000).Format('yyyy-MM-dd hh:mm:ss');
                }
                let _obj = {
                    text: _text,
                    status: _status,
                    date: _btime
                };
                return _obj;
            },
            // 搜索
            fnSearch(_isReset = true) {
                if (this.searchSignDate) {
                    this.serchtime = this.searchSignDate[0] + ',' + this.searchSignDate[1];
                } else {
                    this.serchtime = '';
                }
                this.currentPage = _isReset ? APP.PAGE.SKIP_PAGE : this.currentPage;
                this.fnGetData({
                        page: this.currentPage,
                        size: this.pageSize,
                        sn: this.searchNumber,
                        name: this.searchName,
                        record_type: this.searchRecordType,
                        model: this.searchModel,
                        type: this.searchType,
                        status: this.searchStatus,
                        create_at: this.serchtime
                    },
                    res => {
                        this.cardData = res.query;
                        this.pageTotal = res.count;
                    }
                );
            },
            // 打开编辑设备窗口
            fnOpenEditWin(_data) {
                this.form.type = _data.type;
                this.form.sn = _data.sn;
                this.form.name = _data.name;
                this.form.record_type = _data.record_type.toString();
                this.addEqptVisible = true;
            },
            // 编辑设备
            fnEditEqpt() {
                if (!this.form.name) {
                    this.$message.warning('设备名不能为空');
                    return;
                }
                request({
                        url: 'accessEqpt/edit',
                        method: 'POST',
                        data: {
                            sn: this.form.sn,
                            name: this.form.name,
                            record_type: this.form.record_type
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.addEqptVisible = false;
                        this.eqptListShow = false;
                        this.fnSearch();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 开门
            fnOpenDoor(_itme) {

                if (this.fnOnlineStatusText(_itme.heartbeatTime).text == '离线') {
                    this.$message.warning('该设备已离线，无法下发命令');
                    return;
                }

                if (_itme.ip != 'mqtt') {
                    this.$message.warning('暂只支持MQTT协议对接设备');
                    return;
                }

                request({
                        url: 'accessEqpt/openDoor',
                        method: 'POST',
                        data: {
                            sn: _itme.sn
                        }
                    })
                    .then(res => {
                        this.$message.success(res.data);
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            }

        }
    };
</script>

<style scoped lang="scss" type="text/scss">
    @import '~@/styles/mixin.scss';
.person_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.person {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 84px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				padding: 0 5px;
				min-width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 625px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
                width: 196px;
                margin: 0 4px 0 40px;
			}
			&:nth-child(2) {
				width: 196px;
                margin-right: 4px;
			}
			&:nth-child(3) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(6) {
				width: 196px;
                margin-right: 4px;
			}
			&:nth-child(7) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(8) {
				width: 196px;
				margin-right: 4px;
			}
			&:nth-child(9) {
				width: 184px;
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 513px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
                        width: 196px;
						margin-right: 4px;
					}
					&:nth-child(2) {
						width: 196px;
					    margin-right: 4px;
					}
					&:nth-child(3) {
						width: 196px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 196px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 196px;
						margin-right: 4px;
					}
					&:nth-child(6) {
						width: 196px;
					    margin-right: 4px;
					}
					&:nth-child(7) {
						width: 196px;
						margin-right: 4px;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					&:nth-child(8) {
						width: 196px;
						margin-right: 4px;
						cursor: pointer;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					&:nth-child(9) {
                        width: 184px;
					}
					img {
						width: 40px;
						height: 40px;
						border-radius: 50%;
					}
					div {
						@include flex-box(center, center);
					}
				}
			}
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>>.el-select__caret {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown {
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
.dialog_editdevice {
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 800px;
		height: 500px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}

.btn_orange {
    background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
    background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Access/accessDefault/index.vue